import * as React from 'react';

import { useSelector } from 'react-redux';
import pickupHero from '../../assets/pickupHero.png';
import deliveryHero from '../../assets/deliveryHero.png';

import styles from './Dispensaries.module.css';

/**
 * This is the dispensaries hero graphic
 */
const DispensariesHeader = () => {
  
  const isPickup = useSelector(state => state.is_pickup);

  return (
    <div className={styles.heroHeader}>
      { isPickup
        ? <img alt="Pickup" className={styles.heroImg} src={pickupHero} />
        : <img alt="Delivery" className={styles.heroImg} src={deliveryHero} />
      }
    </div>
  )
}

export default DispensariesHeader;